import { render, staticRenderFns } from "./CopyrightFileWrapper.vue?vue&type=template&id=09e5df40&scoped=true&"
import script from "./CopyrightFileWrapper.vue?vue&type=script&lang=js&"
export * from "./CopyrightFileWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e5df40",
  null
  
)

export default component.exports